import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container, Typography, Grid, Paper, Button } from "@mui/material";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { format } from "date-fns";

function PackageDetailsPage() {
  // const { packageId } = useParams();

  // const packageDetails = packagesData.packages.find(pkg => pkg.id.toString() === packageId);

  // console.log("URL Package ID:", packageId);
  // console.log("Found Package:", packageDetails);

  // if (!packageDetails) {
  // 	return <h2>Package not found</h2>;
  // }

  // return (
  // 	<div id="package_details">
  // 		<div className="details-banner" style={{ backgroundImage: `url(${packageDetails.image})`}}>
  // 			<div className="banner-content">
  // 				<h1>{packageDetails.location} Package</h1>
  // 				<p>Africa 	&rarr; South Africa &rarr; Cape Town</p>
  // 			</div>
  // 		</div>
  // 		<p><strong>Duration:</strong> {packageDetails.duration}</p>
  // 		<p><strong>Dates:</strong> {packageDetails.dates}</p>
  // 		<p><strong>Description:</strong> {packageDetails.description}</p>
  // 		<p><strong>Price:</strong> {packageDetails.price}</p>
  // 	</div>
  // );
  const { id } = useParams();
  const [packageDetails, setPackageDetails] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPackageAndDestination = async () => {
      try {
        // Fetch package data
        const packageRef = doc(db, "packages", id);
        const packageSnap = await getDoc(packageRef);

        if (!packageSnap.exists()) {
          setNotFound(true);
          setLoading(false);
          return;
        }

        const packageData = {
          id: packageSnap.id,
          ...packageSnap.data(),
        };

        // Fetch destination data using destinationId from the package
        let destinationData = null;
        if (packageData.destinationId) {
          const destinationRef = doc(
            db,
            "destinations",
            packageData.destinationId
          );
          const destinationSnap = await getDoc(destinationRef);

          if (destinationSnap.exists()) {
            destinationData = {
              id: destinationSnap.id,
              ...destinationSnap.data(),
            };
          }
        }

        // Combine package and destination data into a single object
        const combinedData = {
          ...packageData,
          destination: destinationData,
        };

        setPackageDetails(combinedData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setNotFound(true);
        setLoading(false);
      }
    };

    fetchPackageAndDestination();
  }, [id]);

  useEffect(() => {
    if (packageDetails) {
      console.log(JSON.stringify(packageDetails));
    }
  }, [packageDetails]);

  // Helper function to format Firestore timestamps
  const formatDate = (timestamp) => {
    if (!timestamp?.seconds) return "N/A";
    return format(new Date(timestamp.seconds * 1000), "dd MMM yyyy");
  };

  if (loading) {
    return (
      <div className="p-5">
        <p align="center">Loading...</p>
      </div>
    );
  }

  if (notFound) {
    return (
      <div className="p-5">
        <h5>
          Package not found.
        </h5>
      </div>
    );
  }

  return (
    <div id="package_details">
	  <div className="details-banner" style={{ backgroundImage: `url(${packageDetails.images[0]})`}}>
			<div className="banner-content">
				<div className="title-container">
					<i className="bi bi-geo-fill"></i>
					<h1>{packageDetails.title}</h1>
					<p>Africa &rarr; {packageDetails.country} &rarr; {packageDetails.city}</p>
				</div>
				<div className="price-container">
					<span>From</span>
					<h3 className="price">R{parseFloat(packageDetails.price).toLocaleString()} pps</h3>
				</div>
			</div>
		</div>

      <div className="content-container">
		<div className="row">
			<div className="col-sm-8">
					<div className="quick-info">
						<div className="experience">
							<span>Travel Period</span>
							<h4>{formatDate(packageDetails.travelPeriod?.startDate)} -{" "}
							{formatDate(packageDetails.travelPeriod?.endDate)}</h4>
						</div>
						<div className="days">
							<span>Days</span>
							<h4>{packageDetails.duration} days / {packageDetails.duration - 1 } nights</h4>
						</div>
					</div>
					<div className="images-container">
						<div className="first-img">
							<img
								src={packageDetails.images[0]}
								alt={`Package Image primary image`}
							/>
						</div>
						<div className="img-thumbnails">
							{packageDetails.images?.length > 0 && (
								<>
									{packageDetails.images.map((image, index) => (
										<div key={index}>
											<img
												src={image}
												alt={`Package Image ${index + 1}`}
											/>
										</div>
									))}
								</>
							)}
						</div>
					</div>
					<div className="info-card shadow-sm">
						<h4 className="card-title">Package Details</h4>
						<p>Duration: {packageDetails.duration} days</p>
						<p>
							Price: ZAR {parseFloat(packageDetails.price).toLocaleString()}
						</p>
					</div>
					{/* Inclusions */}
					<div className="info-card shadow-sm">
						<h4 className="card-title">Includes</h4>
						<ul>
							{Object.entries(packageDetails.inclusions || {}).map(
								([key, value]) => (
									<li key={key}>
										{key} {value.details && (': ' + value.details)}
									</li>
								)
							)}
						</ul>
						{packageDetails.inclusionsDetails && (
							<div className="details">
								<div
									dangerouslySetInnerHTML={{
									__html: packageDetails.inclusionsDetails,
									}}
								/>
							</div>
						)}
					</div>

					{/* Exclusions */}
					{packageDetails.exclusions?.length > 0 || packageDetails.exclusionDetails && (
					<div className="info-card shadow-sm">
						<h4 className="card-title">Excludes</h4>
						<ul>
							{packageDetails.exclusions.map((exclusion, index) => (
								<li key={index}>- {exclusion}</li>
							))}
						</ul>
							{packageDetails.exclusionDetails && (
							<div>
								<div
									dangerouslySetInnerHTML={{
									__html: packageDetails.exclusionDetails,
									}}
								/>
							</div>
						)}
					</div>
					)}

					{/* Experience */}
					{packageDetails.experience?.length > 0 && (
					<div className="info-card shadow-sm">
						<h4 className="card-title">Experiences</h4>
						<ul>
							{packageDetails.experience.map((exp, index) => (
								<li key={index}>{exp}</li>
							))}
						</ul>
					</div>
					)}

					{/* Destination Details */}
					{packageDetails.destination && (
						<div className="info-card shadow-sm">
							<h4 className="card-title">Destination Details</h4>
							<p><strong>{packageDetails.destination.name}</strong></p>
							<p className="desc-text">
								{packageDetails.destination.description}
							</p>
							<p>City: {packageDetails.destination.city}</p>
							<p>
								Country: {packageDetails.destination.country}
							</p>
							<p>State: {packageDetails.destination.state}</p>
							<p>
								Best Season: {packageDetails.destination.bestSeason}
							</p>

							<h6><strong>Destination Images</strong></h6>
							{packageDetails.destination?.images?.length > 0 && (
								<div className="imgs-container">
									{packageDetails.destination?.images.map((image, index) => (
									<div >
										<img
											src={image}
											alt={`Package Image ${index + 1}`}
										/>
									</div>
									))}
								</div>
							)}
						</div>
					)}

					{/* Terms & Conditions */}
					{packageDetails.termsAndConditions && (
					<div className="info-card shadow-sm">
						<h4 className="card-title">Terms & Conditions</h4>
						<div
							dangerouslySetInnerHTML={{
							__html: packageDetails.termsAndConditions,
							}}
						/>
					</div>
					)}
					
			</div>
			<div className="col-sm-4"></div>
		</div>
        
      </div>
    </div>
  );
}

export default PackageDetailsPage;
